import type { InterventionsBatchEditProps } from "./interventions-batch-edit.type";

import BatchEditSelect from "@/modules/batch-edit-select";

import InterventionsBatchEditContent from "./interventions-batch-edit-content";
import { useInterventionsBatchEditProperties } from "./interventions-batch-edit.hook";

const InterventionsBatchEdit = ({
  interventions,
}: InterventionsBatchEditProps) => {
  const { properties, currentProperty, setCurrentProperty } =
    useInterventionsBatchEditProperties(interventions);

  return (
    <div className="interventions-batch-edit">
      <BatchEditSelect
        type="intervention"
        items={interventions}
        properties={properties}
        onPropertyChange={setCurrentProperty}
      />
      <InterventionsBatchEditContent
        property={currentProperty}
        interventions={interventions}
      />
    </div>
  );
};

export default InterventionsBatchEdit;
